import type { CoreApiClient } from "../client";
import type {
  Floor,
  PatchFloorByIdRequestBody,
  PostBuildingFloorsRequestBody,
  PostBuildingFloorsResponseBody,
} from "../types";

export const createFloorMutations = (api: CoreApiClient) => {
  const { request } = api;

  const create = async (
    buildingId: string,
    body: PostBuildingFloorsRequestBody,
  ): Promise<PostBuildingFloorsResponseBody> => {
    const { data } = await request("post", "/buildings/{buildingId}/floors", {
      params: { path: { buildingId } },
      body,
    });
    return data;
  };

  const update = async (floorId: string, body: PatchFloorByIdRequestBody): Promise<Floor> => {
    const { data } = await request("patch", "/floors/{floorId}", {
      params: { path: { floorId } },
      body,
    });
    return data;
  };

  const deleteFloor = async (floorId: string): Promise<void> => {
    await request("delete", "/floors/{floorId}", {
      params: { path: { floorId } },
    });
  };

  return {
    create,
    update,
    delete: deleteFloor,
  };
};
